<template>
  <div class="wrap myoreders-wrap personal-wrap flex-column">
    <mu-infinite-scroll :loading="pay.loading" :loadingText="pay.message" class="load maskloading" v-show="pay.loading"/>
    <mu-infinite-scroll :loading="loadShow" loadingText="拼命加载中" class="load" v-if="loadShow" />
    <div class="flex-item" v-if="!loadShow">
      <div>
        <div class="orders-list detail">
          <!-- 正常流程 -->
          <div class="time-line four" v-if="orderStateType!=0 && orderStateType!=2  && orderStateType!=10 && orderStateType!=11">
            <div v-for="(orderType,typeIndex) in memOrderDetailMsg.orderOperMsgs" v-if="typeIndex!=0 && typeIndex!=5" class="time-line-item" :class="{'nowStyle':orderType.operIndex==2,'finishStyle':orderType.operIndex==1}">
              <!-- <div class="line"></div> -->
              <p class="state">{{orderType.operName}}</p>
              <div class="point-box">
                <div class="point"></div>
                <div class="line"></div>
              </div>
              <p class="time" v-if="orderType.operIndex!=3">{{orderType.operTime}}</p>
            </div>
          </div>
          <!-- 退单流程图 -->
          <div class="time-line three" v-if="orderStateType==10 ||  orderStateType==11">
            <div class="time-line-item" v-for="(orderType,typeIndex) in memOrderDetailMsg.orderOperMsgs" :class="{'nowStyle':orderType.operIndex==2,'finishStyle':orderType.operIndex==1}">
              <p class="state">{{orderType.operName}}</p>
              <div class="point-box">
                <div class="point"></div>
                <div class="line"></div>
              </div>
              <p class="time" v-if="orderType.operIndex!=3">{{orderType.operTime}}</p>
            </div>
          </div>
          <div class="orders-list-item">
            <div class="orders-list-item-state">
              <div class="state">
                订单状态：<span class="primary">{{memOrderDetailMsg.orderStateName}}</span>
                <samp style="float: right;" v-if="memOrderDetailMsg.orderStateName=='等待支付'">支付剩余:{{memOrderDetailMsg.remainPayTime}}</samp>
                <br/> 订单号：
                <span class="black">{{memOrderDetailMsg.stOrderId}}</span>
                <br/> 下单时间：
                <span class="black">{{memOrderDetailMsg.orderTime}}</span>
              </div>
              <div class="operate" v-if="orderStateType==0">
                <mu-raised-button label="取消订单" class="orders-button mu-raised-button-grad" @click="cancelOrder(orderStateType,memOrderDetailMsg.stOrderId)" />
                <!-- <mu-raised-button label="立即支付" class="orders-button fr" primary @click="orderSubmit(1)" /> -->
              </div>
              <div class="operate" v-if="orderStateType==1 ||orderStateType==3 ||orderStateType==4 ||orderStateType==12||orderStateType==13 " >
                <mu-raised-button label="申请退单"class="orders-button mu-raised-button-grad fr" @click="cancelOrder(orderStateType,memOrderDetailMsg.stOrderId)" />
              </div>
              <div class="clear"></div>
              <div class="operate" v-if="orderStateType==2||orderStateType==10 ">
                <mu-raised-button label="立即购买" class="orders-button mu-raised-button-grad fr" @click="buyNow()" />
              </div>
              <div class="clear"></div>
              <div class="operate" v-if="orderStateType==9 && commonFinished==false" >
                <mu-raised-buttonlabel="去评价" class="orders-button fr" primary @click="evaluateJump()" />
              </div>
              <div class="clear"></div>
            </div>
            <mu-list>
              <myOrdersItem :width="150" :height="150" v-for="(listShop,shopIndex) in memOrderDetailMsg.goodsOrderMsgs" :cartitem="listShop" :key="shopIndex">
              </myOrdersItem>
            </mu-list>
            <div class="orders-list-item-state">
              <div class="state">
                收货人：<span class="black">{{memOrderDetailMsg.orderAddrMsg&&memOrderDetailMsg.orderAddrMsg.consignee}}</span>
                <br/> 联系电话：
                <span class="black">{{memOrderDetailMsg.orderAddrMsg&&memOrderDetailMsg.orderAddrMsg.mobile}}</span>
                <br/> 收货地址：
                <span class="black"> {{memOrderDetailMsg.orderAddrMsg&&memOrderDetailMsg.orderAddrMsg.address}}</span>
              </div>
            </div>
            <div class="orders-list-item-state">
              <div class="state">
                支付方式：
                <span class="black"> {{memOrderDetailMsg.payTypeName}}</span>
              </div>
            </div>
            <div class="orders-list-item-state" v-if="memOrderDetailMsg.invoiceDat&&memOrderDetailMsg.invoiceData.doInvoice=='1'">
              <div class="state">
                发票类型：<span class="black">{{memOrderDetailMsg.invoiceData&& memOrderDetailMsg.invoiceData.invoiceTypeName}}</span>
                <br/> 发票内容：
                <span class="black">{{memOrderDetailMsg.invoiceData && memOrderDetailMsg.invoiceData.invoiceContentName}}</span>
                <br/> 发票抬头：
                <span class="black">{{memOrderDetailMsg.invoiceData && memOrderDetailMsg.invoiceData.invoiceHead}}</span>
              </div>
            </div>
            <div class="orders-list-item-state">
              <div class="state money">
                商品总额：<span class="primary">￥  {{memOrderDetailMsg.totalPrice}}</span>
                <br/> 运费：
                <span class="primary">￥{{memOrderDetailMsg.postPrice}}</span>
                <br/> 使用优惠券：
                <span class="primary">-￥{{memOrderDetailMsg.discountPrice}}</span>
                <br/> 使用红包:
                <span class="primary">-￥{{memOrderDetailMsg.redpacketPrice}}</span>
              </div>
              <div class="orderSum">
                实付金额：<span class="primary">￥{{memOrderDetailMsg.finalPrice}}</span>
              </div>
            </div>
          </div>

          <div class="fullbtn-box" v-if="orderStateType==0">
            <mu-raised-button label="微信支付" fullWidth @click="submitOrder" class="full wx"/>
            <mu-raised-button label="银联支付" fullWidth @click="submitUnionOrder" class="full Union"/>
          </div>
        </div>
      </div>
      <mu-dialog :open="quitOrder" title="取消订单" titleClass="dialogTitle" bodyClass="dialogBody" actionsContainerClass="dialogActionsContainer" @close="quitOrder = false">
        您确定要取消这个订单么?
        <mu-flat-button slot="actions" primary @click="quitOrder = false" label="否" />
        <mu-flat-button slot="actions" primary @click="doQuitOrder(1)" label="是" />
      </mu-dialog>
      <mu-dialog :open="chargeBack" title="申请退单" titleClass="dialogTitle" bodyClass="dialogBody" actionsContainerClass="dialogActionsContainer" @close="chargeBack = false">
        您确定要申请退单么?
        <mu-flat-button slot="actions" @click="chargeBack = false" primary label="否" />
        <mu-flat-button slot="actions" primary @click="doChargeBack()" label="是" />
      </mu-dialog>
      <mu-dialog :open="contactService" title="申请退单请联系客服" titleClass="dialogTitle" bodyClass="dialogBody" actionsContainerClass="dialogActionsContainer fullContainer" @close="contactService = false">
        400-832-2777
        <!-- <mu-flat-button slot="actions" @click="closeContactService" primary label="否"/> -->
        <mu-flat-button slot="actions" primary label="确定" @click="phoneCall('400-832-2777')" />
      </mu-dialog>
      <mu-toast v-if="toast.isShow" :message="toast.messageTip" class="custom-toast" />
    </div>
  </div>
</template>
<script type="text/javascript">
import menus from '@components/menus/menus';
import myOrdersItem from '@components/myOrdersItem/myOrdersItem';
import { mapActions } from 'vuex';
import { storage } from "@common/utils/util.js";
export default {
  data() {
    return {

      settleDatas: [],
      OrderSettleMsg: '',
      loadShow: true, //加载
      quitOrder: false, //取消订单
      chargeBack: false, //申请退单
      contactService: false, //生产中、已发货  联系客服
      cartData: [{
        id: '1',
        title: "这个周末一起吃饭么?这个周末一起吃饭么?这个周末一起起吃饭么?这个周末一起吃饭么?",
        img: "/static/images/headImg.jpg",
        describe: "油漆门特权订金（特价门型不可用）",
        price: 99999,
        count: 1,
      }, {
        id: '2',
        title: "这个周末一起吃饭么?这个周末一起吃饭么?这个周末一起起吃饭么?这个周末一起吃饭么?",
        img: "/static/images/headImg.jpg",
        describe: "油漆门特权订金（特价门型不可用）",
        price: 99999,
        count: 1,
      }],
      value: [], //选中的id
      memOrderDetailMsg: [],
      settleDatas: [],
      stOrderId: this.$route.query.stOrderId, //店铺订单id
      orderStateType: this.$route.query.orderState, //判断进行到那一步骤
      commonFinished: this.$route.query.commonFinished ? this.$route.query.commonFinished : null, //判断是是否出现去评价
      toast:{
            isShow:false,
            messageTip:'',
      },
      pay:{
        loading:false,
        message:'提交订单···'
      }
    }
  },
  methods: {
    ...mapActions({
      getMemOrderDetail: 'getMemOrderDetail', //获取会员订单详情
      applyBackOrder: 'applyBackOrder', //申请退单
      cancelMemOrder: 'cancelMemOrder', //取消订单
      getOrderSettleMsgForOrder: 'getOrderSettleMsgForOrder', //重新购买
      getOrderSettleMsgFromCart: 'getOrderSettleMsgFromCart', //购物车


      doWxMpPay: 'doWxMpPay', //微信公众号支付
      doWxH5Pay:'doWxH5Pay',//微信H5支付
      doUnionWapConsumePay:'doUnionWapConsumePay',//银联手机网页支付

    }),
    showTipMessage(isShow,msg){
        this.toast.isShow = isShow;
        this.toast.messageTip =msg;
        setTimeout(() => { 
          this.toast.isShow = false 
        }, 1500);
    },
    //取消订单
    doQuitOrder(id) {
      this.getCancelMemOrder(this.stOrderId);
      this.$router.push({
        path: '/main/quitsuccess'
      })
    },
    //执行 申请退单
    doChargeBack() {
      this.getApplyBackOrder(this.stOrderId);
    },
    //拨打电话
    phoneCall(tel) {
      
    },
    //立即购买
    // 初始化店铺结算信息
    initSettleDatas(stOrderId,OrderSettleMsg) {
      let _this = this;
      let settleDatas = [];
      let couponAmounts = []; 
      let redpacketAmounts = [];//console.log(this.OrderSettleMsg.storeOrderSettleMsgs)
      OrderSettleMsg.storeOrderSettleMsgs.forEach(function(item) {
        if (item.couponMsgs == null || item.couponMsgs.length == 0) {
          item.couponMsgs = [];
        } else {
          // 优惠券列表中加入  不使用选项
          item.couponMsgs.unshift({
            couponInstId: '0',
            couponName: '不使用优惠券',
            couponAmount: 0,
          });
        }
        if (item.redpacketMsgs == null || item.redpacketMsgs.length == 0) {
          item.redpacketMsgs = [];
        } else {
          // 优惠券列表中加入  不使用选项
          item.redpacketMsgs.unshift({
            couponInstId: '0',
            couponName: '不使用红包',
            couponAmount: 0,
          });
        }
        // 记录结算数据  店铺id 商品id  优惠券默认为0  红包默认0  备注默认为空
        let instSkuIds = [];
        item.settleGoodsMsg.cartGoodses.forEach(function(sub) { //每个店铺下的商品实例id
          instSkuIds.push(sub.instSkuId);
        });

        settleDatas.push({
          stOrderId:stOrderId,
          storeId: item.settleGoodsMsg.storeId,
          instSkuIds: instSkuIds,
          couponInstId: "0",
          redpacketInstId:'0',
          remark: '',
          dealerCode:'',
        });
        //店铺优惠券优惠金额列表
        couponAmounts.push(0)
        redpacketAmounts.push(0)
      });
      let orderData = {};
      orderData.OrderSettleMsg = OrderSettleMsg; //订单信息
      orderData.settleDatas = settleDatas; //店铺结算信息
      orderData.couponAmounts = couponAmounts; //优惠券优惠金额
      orderData.redpacketAmounts = redpacketAmounts;
      storage.local.set('orderData', orderData);
    },
     //立即支付
    orderSubmit(id) {
      let stOrderId = '';
      let _this = this;
      stOrderId = this.memOrderDetailMsg.stOrderId;
      this.getOrderSettleMsgForOrder(stOrderId).then(res => {
        this.OrderSettleMsg = res.target.target;
        this.initSettleDatas(stOrderId,res.target.target); // 初始化店铺结算信息
        this.$router.push({
          path: '/main/firmorder?orderId='+_this.memOrderDetailMsg.orderId
        })
      })
    },
    //立即购买
    buyNow() {
      let stOrderId = '';
      let _this = this;
      stOrderId = this.memOrderDetailMsg.stOrderId;
      this.getOrderSettleMsgForOrder(stOrderId).then(res => {
        this.OrderSettleMsg = res.target.target;
        this.initSettleDatas(stOrderId,res.target.target); // 初始化店铺结算信息
        this.$router.push({
          path: '/main/firmorder'
        })
      })
    },
    //判断是取消订单还是申请退单还是线下操作
    cancelOrder(stated, stOrderId) {
      this.stOrderId = stOrderId;
      if (stated == 0) {
        this.quitOrder = true
      } else if (stated == 4 || stated == 1 || stated == 3 || stated == 12 || stated == 13) {
        this.chargeBack = true;
      } else {
        this.contactService = true;
      }
    },

    //跳转去评价
    evaluateJump(stOrderId, orderId) {
      //this.$router.push({path: '/personal/evaluateAll?stOrderId=' + stOrderId + '&orderId=' + orderId})
    },
    //取消订单api
    getCancelMemOrder(stOrderId) {
      this.cancelMemOrder(stOrderId).then(res => {
        this.showTipMessage(true,'已成功取消订单');
        
        this.$router.push({ path: '/main/myorders' })
      }).catch(error => {
        this.showTipMessage(true,error||'退单失败,请稍后重试');
      })
    }, //申请退单api
    getApplyBackOrder(stOrderId) {
      this.applyBackOrder([stOrderId,'mobile']).then(res => {
        this.showTipMessage(true,'退单申请已提交');
        this.$router.push({
          path: '/main/quitsuccess'
        })
      }).catch(error => {
        this.showTipMessage(true,error||'退单失败,请稍后重试');
      })
    },





    // 微信支付
    submitOrder() {
      let orderId = this.memOrderDetailMsg.orderId ;
      //微信内置浏览器
      if(this.util.isWeiXin()){
          this.pay.loading = true;
          this.pay.message = '等待支付···'
          this.callOldWxPay(orderId);
      }else{
        this.pay.loading = true;
        this.pay.message = '等待支付···'
        //3. 发起H5微信请求
        this.callH5WxPay(orderId);  
      }
    },
    //银联支付
    submitUnionOrder(){
      this.pay.loading = true;
      this.pay.message = '等待支付···'
               
      this.callUnionPay(this.memOrderDetailMsg.orderId);   
    },

    // 银联wap网关支付
    callUnionPay(orderNo){
      this.doUnionWapConsumePay([orderNo]).then(res=>{
          let boxId = "_mxmall_unionpay_box_";
          const div = document.createElement('div');  
          div.id = boxId;
          div.innerHTML = res;
          document.body.appendChild(div);
          document.querySelector("#" + boxId +" > form").submit();
      }).catch(err =>{
        this.showTipMessage(true, JSON.stringify(err));
      })
    },

    //微信H5支付
    callH5WxPay(orderId){
        let _this =this;
        this.doWxH5Pay([orderId || _this.memOrderDetailMsg.orderId]).then(res => {
          if(res.success && res.errCode == 'ORDERPAID'){
            _this.showTipMessage(true,"该订单已支付成功");
            location.href = '/main/paysuccess?orderId='+ orderId || _this.memOrderDetailMsg.orderId 
            return;
          }
          let url = res.target.target;
          //重定向
          location.replace(url); 
          //TODO
        }).catch(err =>{ 
          this.showTipMessage(true, JSON.stringify(err));
        })
    },
    //旧版微信支付
    callOldWxPay(orderId){
      let _this =this;

      if (typeof WeixinJSBridge == "undefined"){
         if( document.addEventListener ){
             document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
         }else if (document.attachEvent){
             document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady); 
             document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
         }
      }else{
          return this.doWxMpPay([orderId || this.memOrderDetailMsg.orderId]).then(resWxPay => {
              //alert("调用服务端doWxMpPay,返回结果resWxPay："+JSON.stringify(resWxPay));  
              if(!resWxPay || !resWxPay.success || !resWxPay.target || !resWxPay.target.success){
                _this.showTipMessage(true, (resWxPay && resWxPay.message) || (resWxPay && resWxPay.target && resWxPay.target.message) || '抱歉，支付失败！');
                //防止重复提交
                location.href = '/main/myorders';
                return;
              } 
              
              WeixinJSBridge.invoke(
                 'getBrandWCPayRequest', {
                     "appId":resWxPay.target.target.appId,     //公众号名称，由商户传入     
                     "timeStamp":resWxPay.target.target.timeStamp,         //时间戳，自1970年以来的秒数     
                     "nonceStr":resWxPay.target.target.nonceStr, //随机串     
                     "package" :resWxPay.target.target.package,     
                     "signType":resWxPay.target.target.signType,         //微信签名方式：     
                     "paySign":resWxPay.target.target.paySign //微信签名 
                 },
                 function(res){  
                    //alert("STEP 4 微信服务器返回结果: " + JSON.stringify(res));
                    // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回   ok，但并不保证它绝对可靠。    
                    if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                        _this.showTipMessage(true, '支付成功');
                        location.href = '/main/paysuccess?orderId='+ _this.memOrderDetailMsg.orderId  || _this.$route.query.orderId                    
                    }
                    else if(res.err_msg == "get_brand_wcpay_request:fail" ) {
                        _this.showTipMessage(true, '支付失败');
                        location.href = '/main/myorders?type=2'
                    }
                    else if(res.err_msg == "get_brand_wcpay_request:cancel" ){
                        _this.showTipMessage(true, '已取消支付');
                        location.href = '/main/myorders?type=2'
                    }
                 }
              ); 
          }).catch(err=>{
            _this.showTipMessage(true, err || '支付失败!');
            location.href = '/main/myorders?type=2';
          })
      }
    },




  },
  watch: {},
  mounted() {
    //当前店铺订单详情
    this.getMemOrderDetail(this.stOrderId).then(res => {
      this.memOrderDetailMsg = res;
      this.loadShow = false;
    }).catch(error => {
      console.log(error);
    });
  },
  components: {
    menus,
    myOrdersItem
  }
}

</script>
<style lang="scss" rel="stylesheet/scss">
@import 'personal.scss';
.myoreders-wrap {}

</style>



// WEBPACK FOOTER //
// orderdetail.vue?1cfb8362